import { ReactNode, useState } from 'react';

import { Piece, PieceType } from '@apiContract';
import ValidationScannerDialog from '@components/QrScannerDialog/ValidationScannerDialog';
import { useSettings } from '@hooks/useSettings';

import { ValidationData } from '../types';

type ActionValidationProps = {
  settingName: string | undefined;
  dialogControlComponent: ReactNode;
  validationDialogOpen: boolean;
  closeValidationDialog: () => void;
  onValidationSuccess: (validationData: ValidationData, validatedIds?: number[]) => void;
  pieceType: PieceType;
  piecesForValidate: Piece[];
  children: ReactNode;
};

export const ActionValidation = ({
  settingName,
  dialogControlComponent,
  validationDialogOpen,
  closeValidationDialog,
  onValidationSuccess,
  pieceType,
  piecesForValidate,
  children,
}: ActionValidationProps) => {
  const [validated, setValidated] = useState<boolean>(false);

  const settings: any = useSettings();

  const validationRequired = pieceType !== PieceType.Mail && !!settingName && !!settings[settingName];

  const onValidationConfirm = (validationData: ValidationData, validatedIds?: number[]) => {
    setValidated(true);
    onValidationSuccess(validationData, validatedIds);
    closeValidationDialog();
  };

  return (
    <>
      {validationRequired && !validated && dialogControlComponent}

      {validationDialogOpen && (
        <ValidationScannerDialog
          open
          title="Validate Items"
          onClose={closeValidationDialog}
          onQrCodeRecognized={onValidationConfirm}
          onFinish={onValidationConfirm}
          piecesForValidate={piecesForValidate}
        />
      )}

      {(!validationRequired || validated) && children}
    </>
  );
};
